export default __webpack_public_path__ + "static/media/doordash.bfb41ec6.svg";